"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionDetailType = {
    isDatabase: function (d) {
        return d.type === 'database';
    },
    isTableauServer: function (d) {
        return d.type === 'tableauserver';
    },
    isFile: function (d) {
        return d.type === 'file';
    },
    isWebDataDirect: function (d) {
        return d.type === 'webdata-direct';
    },
};
//# sourceMappingURL=ConnectionDetail.js.map